export const RefData = {
  itemLocationTypeOptions: '6073_picklistvalues',
  registrationStateOptions: '6007_picklistvalues',

  boiler: {
    subTypeOptions: '6022_picklistvalues',
    hazardLevelOptions: '6014_picklistvalues',
    outputUnitOptions: '6026_picklistvalues',
    attendanceOptions: '6027_picklistvalues',
  },

  pressureVessel: {
    subTypeOptions: '6011_picklistvalues',
    numberOfChambersOptions: '6010_picklistvalues',
    hazardLevelOptions: '6014_picklistvalues',
  },

  lift: {
    subTypeOptions: '6033_picklistvalues',
    locationTypeOptions: '6046_picklistvalues',
    suspensionTypeOptions: '6035_picklistvalues',
    carriageTypeOptions: '6037_picklistvalues',
    controlTypeOptions: '6038_picklistvalues',
  },

  amusementDevice: {
    subTypeOptions: '6049_picklistvalues',
    deviceClassOptions: '6048_picklistvalues',
    mobilityTypeOptions: '6072_picklistvalues',
    operatingPowerOptins: '6052_picklistvalues',
    intrinsicSafetyOptions: '6054_picklistvalues',
  },

  mobileCrane: {
    subTypeOptions: '6069_picklistvalues',
  },

  towerCrane: {
    subTypeOptions: '6065_picklistvalues',
  },

  concretePlacingBoom: {
    subTypeOptions: '6079_picklistvalues',
  },

  plantItemType: {
    boiler: '1',
    pressureVessel: '2',
    lift: '3',
    escalator: '4',
    movingWalkway: '5',
    amusementDevice: '6',
    mobileCrane: '7',
    towerCrane: '8',
    buildingMaintenanceUnit: '9',
    concretePlacingBoom: '10',
  },

  includeElectricalInstallation: 'The device includes an electrical installation',
};
